// components/SeoHelmet.jsx
import { Helmet } from 'react-helmet';

interface SeoHelmetProps {
    title: string;
    description: string;
    image?: string;
    url?: string;
}

const SeoHelmet: React.FC<SeoHelmetProps> = ({ title, description, image, url }) => ( /* eslint-disable-line react/prop-types */
    <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        {image && <meta property="og:image" content={image} />}
        {url && <meta property="og:url" content={url} />}
    </Helmet>
);

export default SeoHelmet;
